import { ADMIN, useCurrentArtistPermissions } from '../../../artists';

function useAdmin() {
  const permissions = useCurrentArtistPermissions();
  return permissions.includes(ADMIN);
}

export function useAuthorized() {
  const admin = useAdmin();

  return admin;
}
